import React from 'react';
import moment from 'moment';
import { requestApi, requestFileApi, API_END_POINT } from '../../common/api';
import {
  setErrorMessage,
  setWarnMessage,
} from './CommonAction';
import {
  UPLOAD_COMPANY_TAB,
  DATE_TIME_FORMAT,
  RESULT_CODE,
  FILE_UPLOAD_PROCESS_TYPE,
} from '../../common/const';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_UPLOAD_STATE = 'UPLOAD/SET_INIT_UPLOAD_STATE';

/**
 * state初期化
 */
export const setInitUploadState = () => ({
  type: SET_INIT_UPLOAD_STATE,
});

/**
 * 表示タブ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_TAB = 'UPLOAD/SET_DISP_TAB';

/**
 * 表示タブ設定
 * @param   {string}  dispTab  表示タブ
 */
export const setDispTab = (dispTab) => ({
  type: SET_DISP_TAB, dispTab,
});

/**
 * 表示日設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_DATE = 'UPLOAD/SET_DISP_DATE';

/**
 * 表示日設定
 * @param   {string}  dispDate  表示日
 */
export const setDispDate = (dispDate) => ({
  type: SET_DISP_DATE, dispDate,
});

/**
 * 選択シーケンスID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_SEQUENCE_ID = 'UPLOAD/SET_SELECT_SEQUENCE_ID';

/**
 * 選択シーケンスID設定
 * @param   {integer}  selectSequenceId  選択シーケンスID
 */
export const setSelectSequenceId = (selectSequenceId) => ({
  type: SET_SELECT_SEQUENCE_ID, selectSequenceId,
});

/**
 * ジョブ一覧設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_JOB_LIST = 'UPLOAD/SET_JOB_LIST';

/**
 * ジョブ一覧設定
 * @param   {object}  jobList  ジョブ一覧
 */
export const setJobList = (jobList = []) => ({
  type: SET_JOB_LIST,
  jobList,
});

/**
 * 選択ジョブ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_JOB = 'UPLOAD/SET_SELECT_JOB';

/**
 * 選択ジョブ設定
 * @param   {object}  selectJob  ジョブ
 */
export const setSelectJob = (selectJob = {}) => ({
  type: SET_SELECT_JOB,
  selectJob,
});

/**
 * 文字コード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHAR_CODE = 'UPLOAD/SET_CHAR_CODE';

/**
  * 文字コード設定
  * @param   {object}  charCode  文字コード
  */
export const setCharCode = (charCode = {}) => ({
  type: SET_CHAR_CODE,
  charCode,
});

/**
 * 年月日エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_DISP_DATE = 'UPLOAD/SET_ERR_DISP_DATE';

/**
 * 年月日エラーフラグ設定
 * @param   {boolean}  errDispDate 年月日エラーフラグ
 */
export const setErrDispDate = (errDispDate) => ({
  type: SET_ERR_DISP_DATE, errDispDate,
});

/**
 * 取引情報ファイルIDリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEMS_ID = 'TARGET/SET_ADDITIONAL_ITEMS_ID';

/**
 * 取引情報ファイルIDリスト設定
 * @param   {object}  additionalItemsIdList  取引情報ファイルIDリスト
 */
export const setAdditionalItemsId = (additionalItemsIdList) => ({
  type: SET_ADDITIONAL_ITEMS_ID, additionalItemsIdList,
});

/**
 * エラーファイルIDリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERROR_FILE_ID = 'TARGET/SET_ERROR_FILE_ID';

/**
 * エラーファイルIDリスト設定
 * @param   {object}  errorFileIdList  エラーファイルIDリスト
 */
export const setErrorFileId = (errorFileIdList) => ({
  type: SET_ERROR_FILE_ID, errorFileIdList,
});

/**
 * ジョブ一覧からシーケンスIDをキーにジョブを抽出
 * @param   {string}  sequenceId  シーケンスID
 */
export const filterJobList = () => (dispatch, getState) => {
  const {
    jobList,
    selectSequenceId,
  } = getState().upload;
  // ジョブ一覧から選択シーケンスIDと一致するジョブを抽出
  const job = jobList.find((record) => record.seq_id === selectSequenceId);
  if (!job) {
    // 選択ジョブを初期化
    dispatch(setSelectJob());
    return false;
  }
  // 選択ジョブを設定
  dispatch(setSelectJob(job));
  return true;
};

/**
 * データ更新ジョブ一覧取得
 * @param    {string}  excutionDate 処理実行日
 */
export const searchUploadJobList = (excutionDate) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    excution_date: excutionDate,
  };
  // データ更新ジョブ一覧取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.UPLOAD_COMPANY_UPDATE_JOBLIST, o);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    // 企業情報更新のステートを初期化
    dispatch(setInitUploadState());
  } else {
    // ジョブ一覧を設定
    dispatch(setJobList(ret.response.job_list));
  }
  // 画面表示日付を設定
  dispatch(setDispDate(excutionDate));
};

/**
 * アップロードファイルステータスチェック
 */
export const checkUploadFileStatus = () => async (dispatch) => {
  // リクエストパラメータ生成
  const f = new FormData();
  f.append('process_type', FILE_UPLOAD_PROCESS_TYPE.STATUS_CHECK);
  // データ更新ファイルアップロードAPIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.UPLOAD_COMPANY_UPDATE, f, true, false);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }

  if (ret.response && ret.response.warning_list) {
    const msgs = [];
    // 正常終了でワーニングメッセージが存在する場合、ワーニングメッセージをメッセージエリアに表示
    ret.response.warning_list.forEach((message, index) => {
      msgs.push(<div key={'warning-'.concat(index)}>{message}</div>);
    });
    dispatch(setWarnMessage(msgs));
  }
  return true;
};

/**
 * ファイルアップロード
 * @param    {FileList}  additionalItemsFileList  取引情報ファイルリスト
 * @param    {string}    charCode         文字コード
 */
export const fileUploadExecute = (
  additionalItemsFileList,
) => async (dispatch, getState) => {
  // リクエストパラメータ生成
  const f = new FormData();
  f.append('process_type', FILE_UPLOAD_PROCESS_TYPE.UPLOAD);
  // 取引情報ファイルリスト
  additionalItemsFileList.forEach((additionalItemsFile) => {
    f.append('additionalitems_file', additionalItemsFile);
  });
  f.append('char_code', getState().upload.charCode);

  // データ更新ファイルアップロードAPIへリクエスト
  const xhr = await requestFileApi(dispatch, API_END_POINT.UPLOAD_COMPANY_UPDATE);
  // レスポンスが正常の場合の処理
  xhr.oncsuccess = () => {
    const response = JSON.parse(xhr.responseText);
    if (response && response.warning_list) {
      const msgs = [];
      // 正常終了でワーニングメッセージが存在する場合、ワーニングメッセージをメッセージエリアに表示
      response.warning_list.forEach((message, index) => {
        msgs.push(<div key={'warning-'.concat(index)}>{message}</div>);
      });
      dispatch(setWarnMessage(msgs));
    }
    if (response.seq_id) {
      // 返却されたシーケンスIDを選択シーケンスIDに設定
      dispatch(setSelectSequenceId(response.seq_id));
    }
    // ジョブ一覧をシステム日時で再取得
    dispatch(searchUploadJobList(moment().format(DATE_TIME_FORMAT.DATE)))
      .then(() => {
        // ジョブ一覧から対象ジョブを抽出
        const ret = dispatch(filterJobList());
        if (ret) {
          // 表示タブを「データ更新結果」に設定
          dispatch(setDispTab(UPLOAD_COMPANY_TAB.RESULT));
        }
      });
  };
  xhr.send(f);
};

/**
 * データ更新実行
 */
export const updateExecute = () => async (dispatch, getState) => {
  // リクエストパラメータ生成
  const f = new FormData();
  f.append('process_type', FILE_UPLOAD_PROCESS_TYPE.UPDATE);
  f.append('seq_id', getState().upload.selectSequenceId);
  // データ更新ファイルアップロードAPIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.UPLOAD_COMPANY_UPDATE, f, true, false);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  return true;
};

/**
 * エラーファイルダウンロード
 * @param    {string}  seqId    シーケンスID
 * @param    {string}  status   ステータス
 * @param    {string}  fileId   ファイルID
 * @param    {string}  fileName ファイル名
 */
export const errorFileDownloadExecute = (seqId, status, fileId, fileName) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    seq_id: seqId,
    status,
    file_id: fileId,
  };
  // ファイル取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_FILE, o, false, true);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }

  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = fileName;
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();

  return true;
};
